export default __webpack_public_path__ + "media/zurb/img/services/process/lift-img-abf5da7615b4700734a3d1fe5db0a077.png";